import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import CommissioningReportContainer from '@totem/components/salesOrders/commissioning/CommissioningReportContainer';
import CommissioningReportFilters from '@totem/components/salesOrders/commissioning/CommissioningReportFilters';
import CommissioningReportTable from '@totem/components/salesOrders/commissioning/CommissioningReportTable';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetCommissioningReport = () => {
  const { onSetTitle } = useContext(WidgetContext);

  return (
    <CommissioningReportContainer
      onRecordTotalChanged={(recordCount: number) =>
        onSetTitle(<RecordCountBadge count={recordCount} />)
      }
    >
      <CommissioningReportFilters />
      <CommissioningReportTable />
    </CommissioningReportContainer>
  );
};

export default WidgetCommissioningReport;
